export const resource = {
  wood: 1,
  soil: 2,
  reed: 3,
  stone: 4,
  grain: 5,
  vege: 6,
  sheep: 7,
  boar: 8,
  cow: 9,
  food: 10,
  beg: 11,
  farmer: 12,
  baby: 13,
  fence: 14,
  stable: 15,
};

export const resource_R = {
  1: "wood",
  2: "soil",
  3: "reed",
  4: "stone",
  5: "grain",
  6: "vege",
  7: "sheep",
  8: "boar",
  9: "cow",
  10: "food",
  11: "beg",
  12: "farmer",
  13: "baby",
  14: "fence",
  15: "stable",
};
